import { ConvertableCode } from './models'

export const getCodeSeasonLabel = (code: ConvertableCode | null): string | null => {
  const season = code?.season
  if (!season?.start_month || !season.end_month) return null

  const formatDate = (day: number, month: number) => `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}`

  return `${formatDate(season.start_day, season.start_month)} - ${formatDate(season.end_day, season.end_month)}`
}
